var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscountTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.44141 12.7384H10.6081M8.52356 10.655H8.53131M8.52547 14.8217H8.53331",
    stroke: "#3F3F3F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41602 3.08077C7.94378 5.65152 12.1124 0.103182 14.5791 2.11673C15.9984 3.27532 15.5498 5.83342 13.7072 7.50008",
    stroke: "#3F3F3F",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5527 5.48193C16.3721 5.63056 16.5559 6.11928 16.8006 7.4754C17.0209 8.69675 17.0827 10.1624 17.0827 10.7863C17.0603 11.0162 16.9604 11.2308 16.8006 11.4058C15.0872 13.1017 11.6869 16.3042 9.97077 17.895C9.29727 18.4629 8.28117 18.4752 7.56639 17.9539C6.10274 16.7105 4.69647 15.305 3.31887 14.0357C2.76543 13.3625 2.77841 12.4055 3.38143 11.7712C5.19694 9.99242 8.4821 6.94776 10.3366 5.26573C10.5225 5.11525 10.7503 5.02113 10.9945 5C11.4106 4.9999 12.1244 5.05273 12.8198 5.0908",
    stroke: "#3F3F3F",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountTag);
export default __webpack_public_path__ + "static/media/discount-tag.793dc91b52d101bf56ecb80e3496fee2.svg";
export { ForwardRef as ReactComponent };